import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
@Injectable()
export class SiteConfigService {
    siteConfig: any = {};

    setSiteConfig(cfg: any) {
        this.siteConfig = cfg;
        return this.siteConfig;
    }

    getSiteConfig() {
        return _.cloneDeep(this.siteConfig);
    }

    getConfig(key, def) {
        return _.get(this.siteConfig, key, def);
    }
 
}
